export default {
    title: `Vos réseaux`,
    delete: `Supprimer ce réseau`,
    edit: 'Éditer les réseaux',
};
